import { declareStorageDomain } from './storageGate';

const ACT_AS_MARKER_KEY = 'act_as_marker';

/**
 * Marqueur minimal d'accompagnement (décision 6 du plan sessions-accompagnées) : écrit à
 * l'entrée en act-as, effacé à la sortie propre. Au démarrage, marqueur présent + overlay
 * mémoire vide = l'app a redémarré pendant un accompagnement -> toast. Il permet de
 * RACONTER ce qui s'est passé, jamais de le REPRENDRE : aucun jeton, aucun identifiant —
 * le forger n'obtiendrait qu'un toast.
 */
export interface ActAsMarker {
    beneficiaryFirstName: string;
}

const storage = declareStorageDomain({
    name: 'act-as-marker',
    // Un marqueur qui survivrait au logout raconterait l'accompagnement au prochain connecté.
    onLogout: (s) => s.remove(ACT_AS_MARKER_KEY),
    // Géré explicitement par enterActAs (écriture) / exitActAs (effacement) — pas de purge
    // automatique, sinon la bascule d'entrée effacerait ce qu'elle vient d'écrire.
    onIdentitySwitch: async () => {}
});

export const setActAsMarker = (marker: ActAsMarker): Promise<void> =>
    storage.setJSON(ACT_AS_MARKER_KEY, marker);

export const getActAsMarker = (): Promise<ActAsMarker | null> =>
    storage.getJSON<ActAsMarker>(ACT_AS_MARKER_KEY);

export const clearActAsMarker = (): Promise<void> => storage.remove(ACT_AS_MARKER_KEY);
